/**
 * States of an offer as defined by the ERP. Mirrors
 * Blexon.ERPServiceAPI.Interfaces.OfferService.OfferState, including its numeric
 * values, because they are persisted as integers.
 */
export enum OfferState {
	/** Submitted by the customer, Blexon has not made an offer yet. */
	WaitingForManualOffer = 0,
	/** An offer is available and Blexon is waiting for the customer. */
	WaitingForCustomerAnswer = 1,
	/** The customer accepted the offer, an order exists now. */
	Accepted = 2,
	/** The customer declined the offer. */
	Declined = 3,
	// 4 was Draft. A request is a draft while it is not sent, see OfferRequestDto.submittedAt.
	/** The manufacturer has finished the offer, Blexon still has to release it. */
	WaitingForReleaseByBlexon = 5,
	/** The customer ordered the samples, the offer itself is still open. */
	WaitingForInspectionParts = 6,
}
